<div class="slide slide--comparison" [style.--slide-accent-color]="titleColor">
	<div class="slide__header">
		<div class="slide__content-copy">
			<typography variant="h/2" class="slide__title">
				<app-report-inline-text
					[text]="title"
					[field]="textFields.title"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
			<div class="slide__date-row">
				<app-icon type="svg" [size]="14">calendar_today</app-icon>
				<typography variant="p/xs_regular" class="slide__date-text">
					{{ dateLabel }}
				</typography>
			</div>
			<typography variant="p/sm_regular" class="slide__summary">
				<app-report-inline-text
					[text]="summaryText"
					[field]="textFields.body"
					[editorMode]="editorMode"
				></app-report-inline-text>
			</typography>
		</div>
	</div>

	<div class="slide__body">
		<typography
			variant="p/sm_medium"
			class="slide__compared"
			*ngIf="compared"
		>
			{{ compared }}
		</typography>

		<div
			class="slide__chart slide__chart-host"
			*ngIf="switchable; else figures"
		>
			<app-report-chart-switch
				[state]="chartSwitch"
				[themeColor]="themeColor"
				[editorMode]="editorMode"
				(chartTypeChange)="chartTypeChange.emit($event)"
			></app-report-chart-switch>
		</div>
		<ng-template #figures>
			<div class="slide__chart">
				<div
					class="slide__matrix"
					*ngIf="matrixRows.length; else cards"
					[style.--slide-matrix-columns]="measures.length"
				>
					<span class="slide__matrix-corner"></span>
					<typography
						variant="p/xs_medium"
						class="slide__matrix-measure"
						*ngFor="let measure of measures"
					>
						{{ measure }}
					</typography>
					<ng-container *ngFor="let row of matrixRows">
						<div class="slide__matrix-entity">
							<span
								class="slide__matrix-dot"
								[style.background]="row.color"
							></span>
							<typography
								variant="p/sm_semibold"
								class="slide__matrix-name"
							>
								{{ row.entity }}
							</typography>
						</div>
						<typography
							variant="p/base_semibold"
							class="slide__matrix-value"
							*ngFor="let cell of row.cells"
							[matTooltip]="cell.source"
							[matTooltipDisabled]="!cell.source"
							matTooltipPosition="above"
							matTooltipClass="report-source-tooltip"
						>
							{{ cell.value }}
						</typography>
					</ng-container>
				</div>
				<ng-template #cards>
					<app-report-chart-drawing
						[block]="chartSwitch.block"
						[themeColor]="themeColor"
						[source]="source"
						[fill]="true"
					></app-report-chart-drawing>
				</ng-template>
			</div>
		</ng-template>

		<typography
			variant="p/xs_regular"
			class="slide__note"
			*ngFor="let note of notes"
		>
			{{ note }}
		</typography>
	</div>

	<div class="slide__footer">
		<app-report-slide-brand class="slide__footer-left">
			<typography variant="p/xxs_regular" class="slide__footer-copy">
				Powered by
			</typography>
			<typography variant="p/xxs_semibold" class="slide__footer-brand">
				lolly
			</typography>
		</app-report-slide-brand>
		<typography variant="p/xxs_regular" class="slide__footer-tag">
			{{ tag }}
		</typography>
	</div>
</div>
